import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  Alert, Button, Empty, Icon, message, Form,
  Spin, Table, Select, DatePicker, Tooltip
} from 'antd';
import '../contacts/contacts.scss';
import AnimateEnter from '../AnimateEnter';
import { bindActionCreators } from 'redux';
import { setContactsCount } from '../../actions/Actions';
import {
  CONTACTS_RESOURCE_NAME,
  SENDERS_RESOURCE_NAME,
  DETAILS_RESOURCE_NAME
} from '../../config/constants';
import { _callResource } from '../../context/_callResource';
import { detailsColumns } from './columns';
import { withCancellablePromise } from '../../hocs/withCancellablePromise';
import MESSAGES from "../../locale/messages";
import TEXTS from "../../locale/texts";
import localeEn from 'antd/es/date-picker/locale/en_US';
import localeRu from 'antd/es/date-picker/locale/ru_RU';
import moment from 'moment';
import 'moment/locale/ru';
import 'moment/locale/kk';
import { DATE_FORMAT } from '../../config/constants';

const { RangePicker } = DatePicker;

class Details extends Component {
  state = {
    contacts: [],
    isLoading: true,
    showBlackList: false,
    selectedRows: [],
    isDeleteLoading: false,
    isMounted: true,
    filter: '',
    senders: [],

    tableIsLoading: false,

    PAYLOAD: {
      sender: null,
      type: "MO", // sms message type
      from: moment(new Date()).subtract(1, 'month'),
      to: moment(new Date()),
      currentPage: 0,
      perPage: 30
    },

    startDateDefault: moment(new Date()).subtract(1, 'month'),
    endDateDefault: moment(new Date()),

    minStartDate: moment(new Date()).subtract(3, 'month'),

    // details resource
    detailsData: null,
    detailsDataIsLoading: false,
    detailsDataError: null,

    detailsExportIsLoading:false,
    detailsExportError:null,

    sendersDataIsLoading: false,
    sendersDataError: null,

    // contacts delete resource
    contactsDeleteIsLoading: false,
    contactsDeleteError: false,

    // contacts export resource
    contactsExportIsLoading: false,
    contactsExportError: false,

    blacklistContactsIsLoading: false,
    blacklistContactsError: null,
  };

  callResource = _callResource.bind(this);
  columns = detailsColumns.bind(this);

  getSenders = () => {
    const { promiseCancelToken, location: { state: locationState }, lang } = this.props;
    this.callResource({
      resourceName: SENDERS_RESOURCE_NAME,
      apiClassName: 'senders',
      action: 'get',
      promiseCancelToken,
      onSuccess: ({ data }) => {
        const senders = data
          .filter(({ details }) => details)
          .map(({ sender }) => sender);
        this.setState({
          senderIsMounted: true,
          senders
        });
        if (!locationState) {
          this.setState({
            PAYLOAD: {
              ...this.state.PAYLOAD,
              sender: senders[0]
            }
          });
        }
      },
      onError: () => {
        this.setState({ senderIsMounted: true });
        message.error(TEXTS.campaignSendersError[lang], 7);
      }
    });
  };

  getDetails = (pageNumber = 0) => {
    const { promiseCancelToken } = this.props;
    const { PAYLOAD } = this.state;

    this.setState({
      detailsDataIsLoading: true
    });

    this.callResource({
      resourceName: DETAILS_RESOURCE_NAME,
      apiClassName: 'details',
      action: 'get',
      apiCallParams: {
        ...PAYLOAD,
        from: moment(PAYLOAD.from).format(DATE_FORMAT),
        to: moment(PAYLOAD.to).format(DATE_FORMAT),
        perPage: PAYLOAD.perPage,
        currentPage: pageNumber
      },
      promiseCancelToken,
      onSuccess: () => {
        this.setState({
          tableIsLoading: false,
        });
      }
    });
  };

  componentDidMount() {
    this.getSenders();
  };

  createContact = () => {
    this.props.history.push('/phonebook/contacts/create');
  };

  importContact = () => {
    this.props.history.push('/phonebook/contacts/import');
  };

  exportUsageDetails = () => {
    const { promiseCancelToken, lang } = this.props;
    const { PAYLOAD } = this.state;
    this.callResource({
      resourceName: DETAILS_RESOURCE_NAME,
      apiClassName: 'details',
      action: 'download',
      apiCallParams: {
        ...PAYLOAD,
        from: moment(PAYLOAD.from).format(DATE_FORMAT),
        to: moment(PAYLOAD.to).format(DATE_FORMAT)
      },
      promiseCancelToken,
      notification: {
        text: TEXTS.messageExportUsageDetails[lang]
      }
    });
  };

  resetSearch = () => {
    this.setState({ filter: '' });
  };

  disableDates = (current) => {
    // the dates that can not be selected
    return current && ( current > moment(new Date()) || current < this.state.minStartDate )
  };

  onSenderChange = (sender) => {
    this.setState({
      PAYLOAD: {
        ...this.state.PAYLOAD,
        sender
      }
    });
  };

  onSmsTypeChange = (type) => {
    this.setState({
      PAYLOAD: {
        ...this.state.PAYLOAD,
        type
      }
    });
  };

  onDateChange = (date) => {
    let [ startDate, endDate ] = date;
    startDate = startDate && startDate.format('YYYY-MM-DD');
    endDate = endDate && endDate.format('YYYY-MM-DD');

    this.setState({
      PAYLOAD: {
        ...this.state.PAYLOAD,
        from: startDate,
        to: endDate
      }
    });
  };

  renderData = () => {
    const {
      detailsData,
      isMounted,
      detailsDataError,
      tableIsLoading,
      PAYLOAD
    } = this.state;
    const { lang } = this.props;

    if (detailsDataError) {
      const { errorTitle, errorMessage } = detailsDataError;
      return (
        <Alert
          message={errorTitle}
          description={errorMessage}
          type="error"
        />
      );
    }

    const { totalRows } = detailsData || {};
    const details = detailsData ? detailsData.items : [];
    const columns = this.columns(lang, PAYLOAD.perPage, PAYLOAD.currentPage);

    // TODO: ADD MORE STATUSES FROM PM TASK

    return (
      <AnimateEnter
        paginationAnimate={{ isMounted }}
      >
        <Table
          loading={tableIsLoading}
          locale={{
            emptyText:
              <Empty image={Empty.PRESENTED_IMAGE_SIMPLE}
                     description={detailsData ? TEXTS.tableNoDataDetails[lang] : TEXTS.tableCallToActionDetails[lang]} />
          }}
          columns={columns}
          dataSource={details}
          rowKey={({ id }) => id}
          pagination={{
            defaultCurrent: PAYLOAD.currentPage + 1,
            pageSize: PAYLOAD.perPage,
            hideOnSinglePage: true,
            total: totalRows,
            size: 'large',
            onChange: (page) => {
              window.scrollTo(0,172);
              this.setState(prevState => ({
                tableIsLoading: true,
                PAYLOAD: {
                  ...prevState.PAYLOAD,
                  currentPage: page - 1
                }
              }), () => {
                this.getDetails(page - 1);
              });
            }
          }}
        />
      </AnimateEnter>
    )
  };
  render() {
    const { lang } = this.props;
    const {
      detailsDataIsLoading,
      senders: _senders,
      PAYLOAD,
      tableIsLoading,
      sendersDataIsLoading,
      sendersDataError,
      detailsExportIsLoading,
      detailsData,
      detailsExportError
    } = this.state;

    moment.locale(lang);
    console.log('lang:::', lang);

    const sendersNew = _senders ? _senders.map((item, i) => {
      return <Select.Option value={item} key={i}>{item}</Select.Option>;
    }) : [];
    return (
      <div style={{paddingBottom: 50}}>
        <section className="submenu all-contacts bg-white table-header">
            <div className="form-row" style={{display: 'inline-block', verticalAlign: 'bottom', marginRight: 20}}>
              <label style={{lineHeight: 1}}>{TEXTS.campaignSenderLabel[lang]}</label>
              <br />
              <Form.Item validateStatus={sendersDataError ? 'error' : 'false'} style={{marginBottom: 0}}>
                <Select
                  loading={sendersDataIsLoading}
                  defaultValue={PAYLOAD.sender || (_senders ? _senders[0] : '')}
                  size="large" style={{ width: 172 }} onChange={this.onSenderChange}
                  value={PAYLOAD.sender}>
                  {sendersNew}
                </Select>
              </Form.Item>
            </div>
            <div className="form-row" style={{display: 'inline-block', verticalAlign: 'bottom', marginRight: 20}}>
              <label style={{lineHeight: 1}}>
                МО/МТ
                <Tooltip title={TEXTS.momtTooltip[lang]} placement="right">
                  <Icon type="info-circle" style={{display: 'inline-block', verticalAlign: 'bottom', marginLeft: 5}} />
                </Tooltip>
              </label>
              <br />
              <Select
                defaultValue="МО"
                size="large" style={{ width: 172 }}
                onChange={this.onSmsTypeChange}
                value={PAYLOAD.type}>
                <Select.Option value="MO">MO</Select.Option>
                <Select.Option value="MT">MT</Select.Option>
                <Select.Option value="3" disabled>МО и МТ</Select.Option>
              </Select>
            </div>
            <div className="form-row" style={{display: 'inline-block', verticalAlign: 'bottom'}}>
              <label style={{lineHeight: 1}}>
                {TEXTS.campaignDateTimeLabel[lang]}
                <Tooltip title={TEXTS.detailsTooltip[lang]} placement="right">
                  <Icon type="info-circle" style={{display: 'inline-block', verticalAlign: 'bottom', marginLeft: 5}} />
                </Tooltip>
              </label>
              <br />
              <RangePicker
                style={{width: 256, textAlign: 'left', fontSize: 18}}
                defaultValue={[this.state.startDateDefault, this.state.endDateDefault]}
                disabledDate={this.disableDates}
                format="DD-MM-YYYY"
                locale={lang === 'en' ? localeEn : localeRu}
                size="large"
                onChange={this.onDateChange}
                separator="–"
              />

              {/*<DatePicker*/}
                {/*className="mr-3"*/}
                {/*size="large"*/}
                {/*placeholder={TEXTS.campaignDatePlaceholder[lang]}*/}
                {/*format="DD-MM-YYYY"*/}
                {/*disabledDate={this.disabledDate}*/}
                {/*onChange={this.onDateChange}*/}
                {/*locale={lang === 'en' ? localeEn : localeRu}*/}
              {/*/>*/}
            </div>

          <div className="form-row" style={{display: 'inline-block', marginLeft: 20}}>
            <Button
              type="primary"
              size="large"
              disabled={detailsDataIsLoading || (_senders && _senders.length === 0) || sendersDataIsLoading}
              style={{padding: '0 20px', height: 40, fontSize: 15}}
              onClick={() => {
                this.setState(({ PAYLOAD }) => ({
                  PAYLOAD: {
                    ...PAYLOAD,
                    currentPage: 0
                  }
                }));
                this.getDetails(0);
              }}
            >
              {TEXTS.btnGetDetails[lang]}
            </Button>
          </div>
          <div className="form-row" style={{display: 'inline-block', marginLeft: 20}}>
            <Button
              size="large"
              block
              disabled={detailsDataIsLoading  || detailsExportIsLoading || (_senders && _senders.length === 0) || sendersDataIsLoading }
              loading={detailsExportIsLoading}
              icon='export'
              style={{padding: '0 20px', height: 40, fontSize: 15}}
              onClick={this.exportUsageDetails}
            >
              {TEXTS.btnExportUsageDetails[lang]}
            </Button>
          </div>
        </section>
        <section className="all-campaigns">
          {detailsDataIsLoading && !tableIsLoading
            ? <Empty description={TEXTS.dataIsLoading[lang]}>
                <div style={{marginTop: 15, textAlign: 'center'}}>
                  <Spin spinning={true} />
                </div>
              </Empty>
            : this.renderData()}
        </section>
      </div>
    )
  }
}

export default withCancellablePromise(
  connect(state => ({
    lang: state.lang,
  }), dispatch => ({
    setContactsCount: bindActionCreators(setContactsCount, dispatch),
  }))(withRouter(Details)), 'getContacts');
